import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { IBulkOperationResult, IFileAttachment } from '../../surveys/models/Api';

export const useClientUploadSurveyAttachmentByToken = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IBulkOperationResult<IFileAttachment>) => void;
	onSuccess?: (data: IFileAttachment[]) => void;
}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: ({
			file,
			accessToken,
			surveyType,
		}: {
			file: File;
			accessToken: string;
			surveyType: 'custom' | 'donation' | 'eventRegistration';
		}) => {
			const formData = new FormData();
			formData.append('files', file);

			return apiClient.postBulk<IFileAttachment>(
				`survey/${surveyType}/response/byToken/fileUpload?token=${accessToken}`,
				formData
			);
		},
		onError,
		onSuccess,
	});
};
